<div class="flex flex-col h-full">
  <div class="flex-1 overflow-hidden">
    <elcia-permission-matrix
      (onToggle)="onToggle($event)"
      [isLoading]="isLoading()"
      [permissions]="permissions()"
      [rows]="rows()"/>
  </div>
</div>
